import { ContentGameListData, GameItemContent } from 'components/AlchemyContent/types/gameList'

import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import React from 'react'
import { BoxProps } from 'UIKit/Box/types'
import ScrollBlockList from '../Layout/ScrollBlockList'
import GameItem from './GameItem'

export type GameListProps = {
  data: ContentGameListData
}

const NUMBER_OF_ITEMS_IN_DESKTOP = 4
const NUMBER_OF_ITEMS_IN_MOBILE = 3

const ItemWrapper = ({ item, ...props }: { item: GameItemContent } & BoxProps) => {
  return <GameItem game={item} {...props} />
}

const GameList: React.FC<GameListProps> = ({ data }) => {
  const { isMobile } = useMatchBreakpoints()
  return (
    <ScrollBlockList
      title={data.headingTitle}
      items={data.game}
      ItemBlock={ItemWrapper}
      numberOfItems={isMobile ? NUMBER_OF_ITEMS_IN_MOBILE : NUMBER_OF_ITEMS_IN_DESKTOP}
    />
  )
}

export default GameList
